import React from 'react';
import './ourmission.css';

const OurMission = () => {
  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Our Mission</h2>
      <div className="row align-items-center">
        {/* Left Column - Text */}
        <div className="col-md-6">
          <p style={{ textAlign: 'justify' }}>
            At <strong>Inovaantage</strong>, our mission is to drive positive transformation in organizational
            performance while simultaneously enhancing the quality of life for individuals. We believe that
            businesses must leverage scientific and technological advancements to improve society and the world
            as a whole.
          </p>
          <p style={{ textAlign: 'justify' }}>
            Our commitment is to ensure that technology serves humanity in meaningful and ethical ways —
            contributing to a more sustainable and equitable planet. While the journey is long, we remain
            passionate about making a significant impact and creating a better future for generations to come.
          </p>
        </div>

        {/* Right Column - Image */}
        <div className="col-md-6 text-center">
          <img
            src="mis.png"
            alt="Our Mission"
            className="img-fluid"
            style={{ maxHeight: '350px', objectFit: 'contain' }}
          />
        </div>
      </div>
    </div>
  );
};

export default OurMission;
